import "../../../../../../../node_modules/bxslider/dist/jquery.bxslider.js";
import {PewComponent} from "../../../assets/raw/js/components/pew-component";

// see https://bxslider.com/options/
const SliderOptions = {
    mode: 'horizontal',
    autoControlsCombine: true,
    keyboardEnabled: true,
    easing: 'ease-in-out',
    speed: 700,
    pause: 4000,
    auto: true,
    autoControls: false,
    stopAutoOnClick: true,
    autoHover: true,
    randomStart: true,
    adaptiveHeight: true,
    touchEnabled: (window.innerWidth < 1025)
};

export class SliderTemoignagesComponent extends PewComponent {
    constructor(element) {
        let opts     = SliderOptions;
        let isMobile = (window.innerWidth < 768);

        if (isMobile) {
            opts['minSlides']  = 1;
            opts['maxSlides']  = 1;
            opts['slideWidth'] = 0;
        }

        super(element, opts);
    }

    init() {
        jQuery(window).on("load", () => {
            this.element.bxSlider(this.options);
            setTimeout(()=>{
                this.element.redrawSlider();
            },500);
        });
    }
}

window.pew.addRegistryEntry({key: 'wdf-slider-temoignage', domSelector: '.wdf-slider-temoignage', classDef: SliderTemoignagesComponent});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Temoignage/SliderTemoignageComponent.js